// extracted by mini-css-extract-plugin
module.exports = {"modal":"ResultModal_modal__1shqi","overlay":"ResultModal_overlay__10jtd"};